import { render, staticRenderFns } from "./Koutu_Comment.vue?vue&type=template&id=675211d4&scoped=true"
import script from "./Koutu_Comment.vue?vue&type=script&lang=js"
export * from "./Koutu_Comment.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Comment.vue?vue&type=style&index=0&id=675211d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675211d4",
  null
  
)

export default component.exports